import type { useI18n } from '#i18n'
import type { NuxtApp } from '#app'

type I18n = ReturnType<typeof useI18n<NonNullable<unknown>>>

export const useNuxtI18n = <T extends Record<string, any>>(nuxt?: T | NuxtApp) => {
	const app = nuxt || useNuxtApp()
	return app?.$i18n as I18n
}
